'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _slice = require('lodash/slice');

var _slice2 = _interopRequireDefault(_slice);

var _replace = require('lodash/replace');

var _replace2 = _interopRequireDefault(_replace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lodash = { each: _each2.default, keys: _keys2.default, map: _map2.default, slice: _slice2.default, replace: _replace2.default }; /*
                                                                                                                                       A wrapper for lodash library to include only the utilities that we need.
                                                                                                                                     */

exports.default = lodash;


// WEBPACK FOOTER //
// ./submodules/soompi-js/dist/node/lodash.js